import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setCurrentSpreadIndexReducer = (state: EditorState, action: PayloadAction<number>) => {
  state.currentSpreadIndex = action.payload;
};

export default setCurrentSpreadIndexReducer;
